import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../theme';

export const useLinkDeviceToJobPageStyles = createStyles(({ token }) => ({
  linkDeviceToJobPage: {
    padding: token.padding,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',

    button: {
      width: '100%',
      height: 40,
      marginTop: token.marginLG,
    },

    '.ant-select': {
      width: '100%',
    },
  },

  hiddenDivider: {
    display: 'none',
  },

  jobDetails: {
    'span:first-child': {
      fontWeight: 700,
      color: ThemeColors.COLOR_GREY3,
      marginRight: token.marginXXS,
    },
  },

  barcodeIcon: {
    fontSize: token.fontSizeHeading3,
    color: ThemeColors.COLOR_GREY_BLUISH3,
  },

  scannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    gap: ThemeSpaces.SPACE_MD,
  },

  scannerWrapper: {
    position: 'relative',
    flex: 1,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,
    overflow: 'hidden',

    video: {
      height: '100%',
      objectFit: 'cover',
    },
  },

  scannerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },

  scannerFrame: {
    width: '80%',
    maxWidth: 280,
    aspectRatio: '3 / 2',
    border: '3px solid rgba(255, 255, 255, 0.8)',
    borderRadius: token.borderRadiusLG,
    boxShadow:
      '0 0 0 9999px rgba(0, 0, 0, 0.4), inset 0 0 20px rgba(255, 255, 255, 0.1)',
  },

  scannerHints: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: `${token.paddingSM}px ${ThemeSpaces.SPACE_NORM_15}px`,

    '.ant-typography': {
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      fontWeight: 500,
    },
  },
}));
